import { render, staticRenderFns } from "./FreightLine.vue?vue&type=template&id=2c0337ea&scoped=true&"
import script from "./FreightLine.vue?vue&type=script&lang=js&"
export * from "./FreightLine.vue?vue&type=script&lang=js&"
import style0 from "./FreightLine.vue?vue&type=style&index=0&id=2c0337ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0337ea",
  null
  
)

/* custom blocks */
import block0 from "./FreightLine.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports